import { render } from "./TopCTAs.vue?vue&type=template&id=b08e8094"
import script from "./TopCTAs.vue?vue&type=script&lang=js"
export * from "./TopCTAs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__